<template>
  <b-container>
    <b-row class="my-2">
      <b-col cols="6" md="9">
        <router-link
            :to="`/${home}`"
        >
          <b-img class="m-2 d-md-none"
                 center
                 src="@assets/images/logo_biblioteca_small.png"
                 fluid
                 :alt="title">
          </b-img>
          <b-img class="m-2 d-none d-md-block"
                 center
                 src="@assets/images/logo_biblioteca.png"
                 fluid
                 :alt="title">
          </b-img>
        </router-link>
      </b-col>
      <b-col>
        <b-row class="h2 mb-0 text-end">
          <b-col>
            <b-link v-for="account in social"
                    :key="account.id"
                    class="m-2"
                    :href="account.url"
                    target="_blank"
            >
              <b-icon
                :icon="account.id"
                class="rounded-circle"
                variant="secondary"/>
            </b-link>
          </b-col>
        </b-row>
        <b-row class="d-md-none">
          <b-col class="text-center p-2">
            <h3>{{ title }}</h3>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { contentComputed } from '@state/helpers';

export default {
  name: "Header",

  props: {
    home: {
      type: String,
      default: 'home'
    },
    title: {
      type: String,
      default: 'No Title'
    }
  },

  computed: {
    ...contentComputed
  }
}
</script>

<style>
  .bi-whatsapp{
    margin-top: -10px;
    fill: #6c757d;
  }
</style>
